import React, {useMemo, forwardRef, createElement} from 'react';
import {renderToString} from 'react-dom/server';
import {getElementAttributes, redirect} from 'helpers';
import {Icons} from 'components';
import css from './icon.module.scss';

export const Icon = forwardRef(({ name, Sub, to, onClick, onPointerDown, Component = Icons[name], ...props }, ref) => {
  if (typeof Sub == 'string') {
    Sub = Icons[Sub];
  }

  const { content, sub } = useMemo(() => ({
    content: Sub && Component && renderToString(<Component />).replace(/<\/?svg[^>]*>/g, '') || undefined,
    sub: Sub && Component && renderToString(<Sub />).replace(/<\/?svg[^>]*>/g, '') || undefined,
  }), [ Sub, Component ]);

  if (to) {
    onClick = () => redirect(to);
  }

  return Boolean(Component) && createElement(Sub ? MaskedIcon : Component, {
    ...getElementAttributes(props),
    className: css('icon', 'icon-' + name, {
      ...props,
      clickable: Boolean(onClick || onPointerDown),
      hasSpinner: Sub === Icons.Spinner,
    }),
    content,
    onClick,
    onPointerDown,
    ref,
    sub,
  });
});

Icon.displayName = 'Icon';

const MaskedIcon = forwardRef(({ content, sub, ...props }, ref) =>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 128 128" {...props} ref={ref}>
    <g className={css('sub-icon')} dangerouslySetInnerHTML={{ __html: sub }} />
    <g mask="url(#sub-mask)">
      <defs>
        <path id="sub-mask-path" d="M128.001061,0 L128.001061,62.7229469 C121.142461,59.0701089 113.31298,57 105,57 C77.9380473,57 56,78.9380473 56,106 C56,113.911524 57.8749945,121.385119 61.2048592,128.000662 L0,128.000662 L0,0 L128.001061,0 Z" />
        <mask id="sub-mask" fill="#fff">
          <use xlinkHref="#sub-mask-path" />
        </mask>
      </defs>
      <g dangerouslySetInnerHTML={{ __html: content }} />
    </g>
  </svg>
);
